import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  workflows = 'workflows',
  workflow = 'workflow',
  workflowInstance = 'workflowInstance',
}

enum ExternalRoutesIds {
  metric = 'metric',
  metrics = 'metrics',
  entities = 'entities',
  entity = 'entity',
  assignmentTable = 'assignmentTable',
  assignmentTablesCreate = 'assignmentTablesCreate',
  factTable = 'factTable',
  flag = 'flag',
  flags = 'flags',
  surface = 'surface',
  experiments = 'experiments',
}

// root route
export const [workflowsRouteImplRef, workflowsRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.workflows });

export const rootRouteRef = workflowsRouteImplRef;

// sub-routes within the plugin
export const [workflowRouteImplRef, workflowRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.workflow,
  path: '/:workflow',
  parent: rootRouteRef,
});

export const [workflowInstanceRouteImplRefLegacy] = createSubRouteRefsPair({
  id: RoutesIds.workflowInstance,
  path: '/:workflow/:id',
  parent: rootRouteRef,
});

export const [workflowInstanceRouteImplRef, workflowInstanceRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.workflowInstance,
    path: '/:workflow/instances/:id',
    parent: rootRouteRef,
  });

// external routes to other plugins
export const metricRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metric,
  params: ['id'],
  optional: true,
});

export const metricsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metrics,
  optional: true,
});

export const entitiesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entities,
  optional: true,
});

export const entityRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entity,
  params: ['id'],
  optional: true,
});

export const assignmentTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTable,
  params: ['id'],
  optional: true,
});

export const assignmentTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTablesCreate,
  optional: true,
});

export const factTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTable,
  params: ['id'],
  optional: true,
});

export const flagRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.flag,
  params: ['id'],
  optional: true,
});

export const flagsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.flags,
  optional: true,
});

export const surfaceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.surface,
  params: ['id'],
  optional: true,
});

export const experimentsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.experiments,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  workflows: workflowsRouteImplRef,
  workflow: workflowRouteImplRef,
  workflowInstance: workflowInstanceRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  workflows: workflowsRouteRef,
  workflow: workflowRouteRef,
  workflowInstance: workflowInstanceRouteRef,

  // external routes to other plugins
  metric: metricRouteRef,
  metrics: metricsRouteRef,
  entities: entitiesRouteRef,
  entity: entityRouteRef,
  factTable: factTableRouteRef,
  flag: flagRouteRef,
  flags: flagsRouteRef,
  assignmentTable: assignmentTableRouteRef,
  assignmentTablesCreate: assignmentTablesCreateRouteRef,
  surface: surfaceRouteRef,
  experiments: experimentsRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
